import { Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Input, Output, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-quarter-year-picker',
  templateUrl: './quarter-year-picker.component.html',
  styleUrls: ['./quarter-year-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuarterYearPickerComponent implements OnInit, OnChanges, OnDestroy {
  @Output() yearsSelected = new EventEmitter<{ year1; year2 }>();
  @Input() quarterStartDate;
  @Input() startQuarter;
  @Input() endQuarter;
  @Input() maxYearOptionLimit: number = 7;
  selectedStartQtr: any;
  selectedStartQtrIndex: any;
  selectedEndQtr: any;
  selectedEndQtrIndex: any;
  selectedQtrs: any[] = [];
  showCalendar: boolean = false;
  qtrYearsList: any[] = [];
  displayTimeFrameDate: any;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.prepareQtrList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['maxYearOptionLimit']['currentValue'] != changes['maxYearOptionLimit']['previousValue']) this.prepareQtrList();
  }

  prepareQtrList() {
    this.qtrYearsList = [];
    const startYear = this.quarterStartDate ? new Date(this.quarterStartDate).getFullYear() : new Date().getFullYear() - 1;
    const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
    const currentQuarter = this.getCurrentQuarter();

    for (let year = startYear; year < startYear + this.maxYearOptionLimit; year++) {
      quarters.forEach((quarter) => {
        this.qtrYearsList.push(`${quarter} ${year}`);
      });
    }

    this.selectedQtrs[0] = currentQuarter;
    this.selectedStartQtr = currentQuarter;
    this.selectedStartQtrIndex = this.qtrYearsList.indexOf(currentQuarter);
    this.restoreCalenderDates();
  }

  restoreCalenderDates() {
    if (this.startQuarter && this.endQuarter) {
      this.displayTimeFrameDate = this.startQuarter + ' - ' + this.endQuarter;
      this.selectedStartQtr = this.startQuarter;
      this.selectedStartQtrIndex = this.qtrYearsList.indexOf(this.startQuarter);
      this.selectedQtrs[0] = this.startQuarter;
      this.selectedEndQtr = this.endQuarter;
      this.selectedEndQtrIndex = this.qtrYearsList.indexOf(this.endQuarter);
      this.selectedQtrs[1] = this.endQuarter;
    }
  }

  getCurrentQuarter() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;

    let currentQuarter: string;

    if (currentMonth <= 3) currentQuarter = 'Q1';
    else if (currentMonth <= 6) currentQuarter = 'Q2';
    else if (currentMonth <= 9) currentQuarter = 'Q3';
    else currentQuarter = 'Q4';

    return `${currentQuarter} ${currentYear}`;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const isClicked = this.el.nativeElement.contains(event.target);
    if (!isClicked) {
      this.showCalendar = isClicked;
    }
  }

  selectYear(yearType: string, Quarter: any) {
    if (yearType == 'selectedStartQtr') {
      if (!this.selectedEndQtr || this.qtrYearsList.indexOf(Quarter) <= this.selectedEndQtrIndex) {
        this.selectedStartQtr = Quarter;
        this.selectedStartQtrIndex = this.qtrYearsList.indexOf(Quarter);
        this.selectedQtrs[0] = Quarter;
      }
    } else if (yearType == 'selectedEndQtr') {
      if (this.qtrYearsList.indexOf(Quarter) >= this.selectedStartQtrIndex) {
        this.selectedEndQtr = Quarter;
        this.selectedEndQtrIndex = this.qtrYearsList.indexOf(Quarter);
        this.selectedQtrs[1] = Quarter;
      }
    }
  }

  applySelectedSet() {
    if (this.selectedQtrs.length == 2) {
      this.displayTimeFrameDate = this.selectedQtrs[0] + ' - ' + this.selectedQtrs[1];
      this.yearsSelected.emit({ year1: this.selectedStartQtr, year2: this.selectedEndQtr });
      this.showCalendar = false;
    }
  }

  clearSelection() {
    this.selectedQtrs = [];
    const currentQuarter = this.getCurrentQuarter();
    this.selectedQtrs[0] = currentQuarter;
    this.selectedStartQtr = currentQuarter;
    this.selectedStartQtrIndex = this.qtrYearsList.indexOf(currentQuarter);
    this.selectedEndQtr = null;
    this.selectedEndQtrIndex = null;
    this.displayTimeFrameDate = null;
    this.yearsSelected.emit({ year1: null, year2: null });
    this.showCalendar = false;
  }

  ngOnDestroy(): void {}
}
